import React, { Component } from "react";
import moment from 'moment';
import {
    VictoryChart,
    VictoryAxis,
    VictoryTheme,
    VictoryArea,
} from "victory";



class SmallStageChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            observedData: [],
            forecastData: [],
            totalData: [],
            tickValues: [],
            startDay: null,
            endDay: null,
            chartMax: 1,
            normal: 0,
            action: 0, 
            minor: 0,
            moderate: 0,
            major: 0
        };
    }

    setChartData = () => {

        if (this.props.data && this.props.data.length > 1) {

            // create formatted date object for observed
            const observed = this.props.data.map(p => {
                p.Date = moment(p.dateTime).format();
                p.Date = new Date(p.Date);
                return p;
            });

            // create formatted date object for observed
            const forecast = this.props.forecastData.map(p => {
                p.Date = moment(p.dateTime).format();
                p.Date = new Date(p.Date);
                return p;
            });

            // total readings
            const total = observed.concat(forecast);

            this.setState({ observedData: observed });
            this.setState({ forecastData: forecast });
            this.setState({ totalData: total });


            // set tick marks to occur daily from day of
            // first observed reading to last forecast reading
            const startDay = moment(total[0].Date);
            const endDay = moment(total[total.length - 1].Date);
            const timeline = endDay.diff(startDay, 'days');

            this.setState({ startDay, endDay });

            const newTickValues = []

            for (let i = 0; i < timeline; i++) {
                var newTickDay = moment(startDay).add(1, 'days')
                newTickValues.push(moment(newTickDay).format('MMM D'))

            }

            this.setState({ tickValues: newTickValues });


            // set flood levels
            const normal = 4;
            const action = 6;
            const minor = 10;
            const moderate = 12;
            const major = 16;
            const chartMax = major + 4;

            this.setState({ normal, action, minor, moderate, major, chartMax });
        }



    }

    componentDidMount() {

        if (this.props.forecastData && this.props.forecastData.length > 0) {
            this.setChartData();
        }

    }

    // if observed or forecast data changes, update set data state again
    componentDidUpdate(prevProps) {

        if ((prevProps.forecastData !== this.props.forecastData) || (prevProps.observedData !== this.props.observedData)) {
            this.setChartData();
        }

    }

    renderStageLabels = (stage) => {
        const stageValues = {
            4: "Normal",
            6: "Action 6ft",
            10: "Minor 10ft",
            12: "Moderate 12ft",
            16: "Major 16ft"
        }

        return stageValues[stage];
    }

 
    render() {

        return (
            <div>

                <VictoryChart
                    padding={{ top: 10, left: 75, right: 50, bottom: 60 }}
                    width={700}
                    height={350}
                    scale={{ x: "time" }}
                    theme={VictoryTheme.material}

                >
                    <VictoryAxis dependentAxis
                        domain={[0, this.state.chartMax]}
                        orientation="left"
                        standalone={false}
                        tickFormat={(t) => `${Math.round(t)} ft`}
                        style={{
                            tickLabels: { fontSize: 20, padding: 5 }
                        }}
            />

                    <VictoryAxis
                        style={{
                            tickLabels: { fontSize: 20, padding: 5 }
                        }}
                                scale="time"
                        />
                    <VictoryArea
                        style={{ data: { fill: "#00CC33", fillOpacity: 0.3, strokeWidth: 0 } }}
                        data={[
                            { x: this.state.startDay, y: this.state.normal, y0: 0 },
                            { x: this.state.endDay, y: this.state.normal, y0: 0 }
                        ]}
                    />
                    <VictoryArea
                        style={{ data: { fill: "#00CC33", fillOpacity: 0.3, strokeWidth: 0 } }}
                        data={[
                            { x: this.state.startDay, y: this.state.action, y0: this.state.normal },
                            { x: this.state.endDay, y: this.state.action, y0: this.state.normal }
                        ]}
                    />
                    <VictoryArea
                        style={{ data: { fill: "#FFCC00", fillOpacity: 0.3, strokeWidth: 0 } }}
                        data={[
                            { x: this.state.startDay, y: this.state.minor, y0: this.state.action },
                            { x: this.state.endDay, y: this.state.minor, y0: this.state.action }
                        ]}
                    />
                    <VictoryArea
                        style={{ data: { fill: "#FF8700", fillOpacity: 0.3, strokeWidth: 0 } }}
                        data={[
                            { x: this.state.startDay, y: this.state.moderate, y0: this.state.minor },
                            { x: this.state.endDay, y: this.state.moderate, y0: this.state.minor }
                        ]}
                    />

                    <VictoryArea
                        style={{ data: { fill: "#FF0000", fillOpacity: 0.3, strokeWidth: 0 } }}
                        data={[
                            { x: this.state.startDay, y: this.state.major, y0: this.state.moderate },
                            { x: this.state.endDay, y: this.state.major, y0: this.state.moderate }
                        ]}
                    />
                    <VictoryArea
                        style={{ data: { fill: "#9900FF", fillOpacity: 0.3, strokeWidth: 0 } }}
                        data={[
                            { x: this.state.startDay, y: this.state.chartMax, y0: this.state.major },
                            { x: this.state.endDay, y: this.state.chartMax, y0: this.state.major }
                        ]}
                    />
                    <VictoryArea
                        style={{
                            data: { fillOpacity: 0.4, stroke: "#3366cc", fill: "#ffffff" }
                        }}
                        data={this.state.observedData ? this.state.observedData : null}
                        x="Date"
                        y={"value"}
                    />
                    <VictoryArea
                        style={{
                            data: { fillOpacity: 0.4, stroke: "#3366cc", fill: "#555555" }
                        }}
                        data={this.state.forecastData ? this.state.forecastData : null}
                        x="Date"
                        y={"value"}
                    />


                </VictoryChart>
            </div>
        );
    }
}

export default SmallStageChart;



// WEBPACK FOOTER //
// ./src/components/SmallStagechart/index.js